import React from 'react';
import { Box, Stack, Typography, Chip } from '@mui/material';
import { useSaleCalendar } from './SaleCalendarContext';

const StateColorLegend = () => {
  const { stateColorLegendObject } = useSaleCalendar();

  return (
    <Box mt={2}>
      <Typography variant="subtitle1" gutterBottom>
        Legenda statusów:
      </Typography>
      <Stack direction="row" spacing={2} flexWrap="wrap">
        {Object.entries(stateColorLegendObject).map(([label, color]) => (
          <Chip
            key={label}
            label={label}
            sx={{
              backgroundColor: color,
              color: '#fff',
              fontWeight: 700,
              fontSize: '0.875rem',
              '& .MuiChip-label': {
                px: 1
              }
            }}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default StateColorLegend;
